import { getText } from '@/lib/i18n/i18n.server';
import { cn } from '@/lib/utils';

import { BlockComponentModel } from '@/cms/types/blok-component';

import {
  BlockHeader,
  generateCMSButtonsForBlockHeader,
  handleRenderButtons,
} from '@/cms/BlockHeaderContentDC';
import Heading from '@/decodo/components/atoms/Heading';
import RichTextFieldStrapi, {
  RichTextFieldStrapiProps,
} from '@/decodo/components/atoms/RichTextField/RichTextFieldStrapi';
import { Text } from '@/decodo/components/atoms/Text';

import { getWrapperMaxWidth } from '@/cms/utils';
import IconMoneyBack from '~/svg/IconMoneyBack.svg';

export interface FooterBannerStrapiProps {
  header: BlockHeader;
  isMoneyBackVisible?: boolean;
}

export default async function FooterBannerStrapi({
  block,
}: BlockComponentModel<FooterBannerStrapiProps>) {
  const { header, isMoneyBackVisible } = block;
  const texts = await getText();

  return (
    <div
      data-tracker-section='footer-banner'
      className='bg-gray-25 relative flex items-center justify-center bg-cover bg-center p-5 py-8 md:px-10 md:py-10'
    >
      <div className='absolute hidden h-full w-full bg-[url("/svg/RainbowWave.svg")] bg-cover bg-fixed bg-center bg-no-repeat md:block' />
      <div
        className={cn(
          getWrapperMaxWidth('mid'),
          'md:bg-gray-25/50 static z-10 flex w-full flex-row items-center gap-6 rounded md:px-5 md:py-10 md:backdrop-blur-[4px]'
        )}
      >
        <div className='flex w-full flex-1 flex-col items-start md:items-center'>
          <Heading level='h2' classNames={{ root: 'mb-6' }}>
            {header.title}
          </Heading>
          {header.subtitle && (
            <div className='mb-9 text-gray-500'>
              <RichTextFieldStrapi
                block={header.subtitle as RichTextFieldStrapiProps}
              />
            </div>
          )}
          {header.buttons && (
            <div
              className={cn(
                'flex w-full flex-wrap justify-center gap-6',
                isMoneyBackVisible ? 'mb-4' : 'mb-9'
              )}
              data-tracker-component='buttons'
            >
              {handleRenderButtons(
                generateCMSButtonsForBlockHeader(header.buttons ?? [])
              )}
            </div>
          )}
          {isMoneyBackVisible && (
            <div className='flex items-center justify-center gap-2 text-gray-500'>
              <IconMoneyBack className='text-success-500 h-5 w-5' />
              <Text variant='body-m' color='gray-500'>
                {texts.pricing_cards.money_back.money_back_option}
              </Text>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
